import { render, staticRenderFns } from "./job-lead-details.vue?vue&type=template&id=b317f14c&scoped=true"
import script from "./job-lead-details.vue?vue&type=script&lang=js"
export * from "./job-lead-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317f14c",
  null
  
)

export default component.exports